import { outcomeMessage } from '../GameOver/outcomeMessage';

/**
 * How a game in the list reads for the player: who it is against and where it stands.
 */
export function gameSummary(game, userId) {
  const opponent = (game.get('users') || [])
    .find(user => user.get('id') !== userId);
  const against = opponent ? `vs ${opponent.get('name')}` : `Game ${game.get('id')}`;

  const outcome = outcomeMessage(game, userId);
  if (outcome) {
    return { against, status: outcome.title, yourMove: false };
  }

  const activePlayerId = game.get('active_player_id');
  if (!activePlayerId) {
    return { against, status: 'Setting up', yourMove: true };
  }

  const yourMove = activePlayerId === userId;
  return { against, status: yourMove ? 'Your turn' : 'Their turn', yourMove };
}
